import { render, staticRenderFns } from "./logo_no_text.vue?vue&type=template&id=473a99df&scoped=true&"
import script from "./logo_no_text.vue?vue&type=script&lang=js&"
export * from "./logo_no_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a99df",
  null
  
)

export default component.exports